const danhSachNguoiDungTheoDanhSachDonVi = state =>
  state.danhSachNguoiDungTheoDanhSachDonVi;
const chiTietNguoiDung = state => state.chiTietNguoiDung;
const nguoiDungGomQuyen = state => state.nguoiDungGomQuyen;
const danhSachVaiTroTheoNguoiDung = state => state.danhSachVaiTroTheoNguoiDung;
const danhSachGroupTheoNguoiDung = state => state.danhSachGroupTheoNguoiDung;
const danhSachVaiTroKhongThuocNguoiDung = state =>
  state.danhSachVaiTroKhongThuocNguoiDung;
const danhSachGroupKhongThuocNguoiDung = state =>
  state.danhSachGroupKhongThuocNguoiDung;
const danhSachQuyenTheoNguoiDung = state => state.danhSachQuyenTheoNguoiDung;
const danhSachQuyenKhongThuocNguoiDung = state =>
  state.danhSachQuyenKhongThuocNguoiDung;
const danhSachNguoiDungTheoGroup = state => state.danhSachNguoiDungTheoGroup;
const danhSachNguoiDungKhongThuocVaiTro = state =>
  state.danhSachNguoiDungKhongThuocVaiTro;
const danhSachNguoiDungTheoVaiTro = state => state.danhSachNguoiDungTheoVaiTro;
const danhSachCanBoLayVaoNguoiDung = state =>
  state.danhSachCanBoLayVaoNguoiDung;

export default {
  danhSachNguoiDungTheoDanhSachDonVi,
  chiTietNguoiDung,
  nguoiDungGomQuyen,
  danhSachVaiTroTheoNguoiDung,
  danhSachGroupTheoNguoiDung,
  danhSachVaiTroKhongThuocNguoiDung,
  danhSachGroupKhongThuocNguoiDung,
  danhSachQuyenTheoNguoiDung,
  danhSachQuyenKhongThuocNguoiDung,
  danhSachNguoiDungTheoGroup,
  danhSachNguoiDungKhongThuocVaiTro,
  danhSachNguoiDungTheoVaiTro,
  danhSachCanBoLayVaoNguoiDung
};
